import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { CrudService } from "./crud.service";
import { Products } from "../models/products";

@Injectable({
  providedIn: "root",
})
export class ProductsService extends CrudService<Products, number> {
  constructor(protected override _http: HttpClient) {
    super(_http, `${environment.baseUrl}/products`);
  }

  getProduct(id: string) {
    return this._http
      .get<Products>(`${this._base}/id/${id}`)
      .pipe(catchError(this.handleProductError));
  }

  createProduct(product: FormData) {
    const userId = this.currentUser.user_id;
    return this._http
      .post<any>(`${this._base}/create/${userId}`, product)
      .pipe(catchError(this.handleProductError));
  }

  updateProduct(product: FormData, id: string) {
    return this._http
      .post<any>(`${this._base}/update/${id}`, product)
      .pipe(catchError(this.handleProductError));
  }

  private handleProductError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error("An error occurred:", error.error.message);
    } else {
      console.error(
        `Backend error — status: ${error.status}, url: ${error.url}, body:`,
        error.error,
      );
    }
    return throwError("Something bad happened. Please try again later.");
  }
}


